// libs
import { styled } from '@nykaa/ui-components';

// constants
import { BASE_GUTTER_SPACE, COLORS, BASE_BORDER_RADIUS } from 'shared/styles/base';

// styles
import { resetButton } from 'shared/styles/mixin/core';

// components
import BaseButton from 'shared/components/Button';
import BaseOverlaySheet from 'shared/components/OverlaySheet';

export const OverlaySheet = styled(BaseOverlaySheet)`
  width: 100%;
  background-color: #fff;
  top: initial;
  animation-duration: 0.3s;
  border-radius: ${2 * BASE_BORDER_RADIUS}px ${2 * BASE_BORDER_RADIUS}px 0 0;
  padding: ${7 * BASE_GUTTER_SPACE}px ${2.5 * BASE_GUTTER_SPACE}px ${2.5 * BASE_GUTTER_SPACE}px
    ${2.5 * BASE_GUTTER_SPACE}px;
`;

export const Title = styled.div`
  ${({ theme }) => theme.typography.type241};
  margin-bottom: ${BASE_GUTTER_SPACE}px;
`;

export const SubTitle = styled.div`
  ${({ theme }) => theme.typography.bodyLarge};
`;

export const PrimaryButton = styled(BaseButton)`
  ${({ theme }) => theme.typography.buttonMedium};
  justify-content: space-between;
  padding: 0 ${BASE_GUTTER_SPACE * 2}px;
  margin: ${BASE_GUTTER_SPACE * 2}px 0;
  height: 48px;
  cursor: pointer;
  background-color: ${COLORS.BLACK_100};
`;

export const ArrowIcon = styled.i`
  display: flex;
  align-items: center;
  transform: rotate(180deg);
  width: 20px;
  height: 20px;
`;

export const Separator = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${COLORS.BLACK_16};
  color: ${COLORS.BLACK_64};
  width: 100%;
  margin: ${BASE_GUTTER_SPACE * 2.5}px 0 ${BASE_GUTTER_SPACE * 1.5}px 0;
  height: 1px;
  & .seperate {
    background: #fff;
    padding: 0 8px;
  }
`;

export const SecondaryButtonContainer = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  margin-top: ${BASE_GUTTER_SPACE * 2}px;
`;

export const SecondaryButton = styled.button`
  ${resetButton}
  border: solid 1px ${COLORS.BLACK_16};
  ${({ theme }) => theme.typography.subTitleLarge};
  letter-spacing: 0.5px;
  color: ${COLORS.BLACK_92};
  height: 48px;
  width: calc(50% - ${BASE_GUTTER_SPACE / 2}px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 ${BASE_GUTTER_SPACE * 2}px;
  cursor: pointer;
`;
